import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'
import { ThumbSlider } from '../modules/thumb-slider.js'
import { SliderControls } from '../modules/slider-controls.js'
//
export default class extends Component {
	prepare() {
		this.slider = new ThumbSlider({
			container: this.element,
			element: this.element.querySelector('.program-slider__inner'),
			emblaOptions: {
				loop: false,
			},
		})

		this.controls = new SliderControls({
			embla: this.slider.getInstance(),
			element: this.element.closest('.slider-section')?.querySelector('.js-slider-controls'),
		})
	}

	mount() {}

	unmount() {
		if (this.controls) {
			this.controls.destroy()
		}
		if (this.slider) {
			this.slider.destroy()
		}
	}
}
